module.exports = __webpack_public_path__ + "static/media/1.9c573216.jpg";